import React, { useMemo } from "react";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import MessagesView from "./messagesView";
import { getTranscriptMessages } from "../../helpers/visitorPastStats";

const TransTab = ({ selectedData, colorCode, isLoading = false }) => {
  const overAllUsers = useSelector((state) => state.Users.overAllUsers);
  const userData = useSelector((state) => state.Auth.userData);

  const transcriptMessages = useMemo(
    () => getTranscriptMessages(selectedData),
    [selectedData]
  );

  return (
    <div className="transcriptPane">
      <div className="head">
        <div className="headerEmail">
          <p className="heading">Name:</p>
          <p className="email">
            {selectedData?.name} [{selectedData?.unique_id}]
          </p>
        </div>
        <div className="headerEmail">
          <p className="heading">Email:</p>
          <p className="email">{selectedData?.email}</p>
        </div>
        <div className="headerEmail">
          <p className="heading">Phone:</p>
          <p className="email">{selectedData?.phone}</p>
        </div>
        <div className="headerEmail">
          <p className="heading">Tags:</p>
          {selectedData?.tags?.map((i, index) => {
            return (
              <p key={index} className="email">
                {i}
              </p>
            );
          })}
        </div>
      </div>
      <div className="transcript">
        {isLoading && transcriptMessages.length === 0 ? (
          <div style={{ textAlign: "center", padding: "24px 0" }}>
            <Spin />
          </div>
        ) : transcriptMessages.length === 0 ? (
          <p style={{ textAlign: "center", padding: "24px 0", color: "#888" }}>
            No messages in this transcript yet.
          </p>
        ) : (
          transcriptMessages.map((message, index) => {
            const findUser = overAllUsers?.find((i) => i?._id == message?.senderID);
            const newUSer = findUser
              ? findUser
              : message?.senderID === userData?._id
                ? { sudoName: userData?.sudoName }
                : { sudoName: userData?._id };

            return (
              <MessagesView
                key={message?.uniqueMessageID ?? message?._id ?? index}
                item={message}
                index={index}
                selectedData={selectedData}
                newUSer={newUSer}
                colorCode={colorCode}
              />
            );
          })
        )}
      </div>
    </div>
  );
};

export default TransTab;
